<div class="agenda-cas-container">
  <p-toast></p-toast>
  <p-confirmDialog></p-confirmDialog>

  <div class="dashboard-header">
    <div class="header-title-block">
      <h1>Agenda Santé</h1>
      <p class="dashboard-subtitle">{{ totalRecords }} RDV(s) santé</p>
    </div>
  </div>

  <p-card styleClass="actions-card">
    <ng-template pTemplate="content">
      <div class="actions-bar">
        <div class="filters-row">
          <div class="search-section">
            <span class="p-input-icon-left">
              <i class="pi pi-search"></i>
              <input
                pInputText
                type="text"
                [(ngModel)]="searchTerm"
                placeholder="Rechercher nom, téléphone, email ou titre..."
                (ngModelChange)="onSearchChange()" />
            </span>
          </div>

          <div class="filter-section">
            <label class="filter-label">Statut</label>
            <p-dropdown
              [options]="statusOptions"
              [(ngModel)]="selectedStatus"
              placeholder="Tous les statuts"
              optionLabel="label"
              optionValue="value"
              [showClear]="true"
              (onChange)="onSearchChange()">
            </p-dropdown>
          </div>

          <div class="filter-section" *ngIf="isAdmin">
            <label class="filter-label">Vendeur</label>
            <p-dropdown
              [options]="userOptions"
              [(ngModel)]="selectedUserId"
              placeholder="Tous les vendeurs"
              optionLabel="label"
              optionValue="value"
              [showClear]="true"
              [filter]="true"
              filterBy="label"
              appendTo="body"
              (onChange)="onSearchChange()">
            </p-dropdown>
          </div>
        </div>

        <div class="toolbar-action-buttons">
          <div class="action-execute-group">
            <p-dropdown
              [options]="actionMenuOptions"
              [(ngModel)]="selectedAction"
              optionLabel="label"
              optionValue="value"
              placeholder="Choisir une action"
              [showClear]="true"
              (onChange)="onActionMenuChange()">
            </p-dropdown>

            <p-dropdown
              *ngIf="selectedAction === 'change_status'"
              [options]="statusOptions"
              [(ngModel)]="selectedBulkStatus"
              optionLabel="label"
              optionValue="value"
              placeholder="Nouveau statut"
              [showClear]="true"
              [disabled]="updatingStatus || loading">
            </p-dropdown>

            <p-dropdown
              *ngIf="selectedAction === 'assign'"
              [options]="userOptions"
              [(ngModel)]="selectedAssignUserId"
              optionLabel="label"
              optionValue="value"
              placeholder="Conseiller cible"
              [showClear]="true"
              [filter]="true"
              filterBy="label"
              appendTo="body"
              [disabled]="assigning || loading">
            </p-dropdown>

            <p-button
              label="Exécuter"
              icon="pi pi-play"
              (onClick)="executeSelectedAction()"
              [disabled]="!canExecuteSelectedAction()"
              [loading]="isExecutingSelectedAction()"
              styleClass="p-button-primary"
              pTooltip="Exécuter l'action sélectionnée">
            </p-button>
          </div>

          <div class="toolbar-utility-buttons">
            <p-button
              icon="pi pi-sun"
              [label]="todayOnly ? 'Aujourd\'hui ✓' : 'Aujourd\'hui'"
              (onClick)="toggleTodayFilter()"
              [styleClass]="todayOnly ? 'p-button-sm today-btn-active' : 'p-button-sm p-button-outlined'"
              pTooltip="Afficher uniquement les RDV d'aujourd'hui">
            </p-button>

            <p-button
              icon="pi pi-inbox"
              [label]="showArchived ? 'Archivés ✓' : 'Archivés'"
              (onClick)="toggleArchivedFilter()"
              [styleClass]="showArchived ? 'p-button-sm today-btn-active' : 'p-button-sm p-button-outlined'"
              pTooltip="Afficher les RDV archivés">
            </p-button>

            <p-button
              icon="pi pi-times"
              (onClick)="clearFilters()"
              [disabled]="!hasActiveFilters()"
              styleClass="p-button-secondary"
              pTooltip="Effacer les filtres">
            </p-button>

            <p-button
              icon="pi pi-refresh"
              (onClick)="refresh()"
              [loading]="loading"
              pTooltip="Actualiser">
            </p-button>
          </div>
        </div>
      </div>
    </ng-template>
  </p-card>

  <!-- Barre de sélection -->
  <div class="selection-bar" *ngIf="selectedProjects.length > 0">
    <div class="selection-info">
      <i class="pi pi-check-circle"></i>
      <span>{{ getSelectedProjectsCount() }} RDV sélectionné(s)</span>
    </div>
    <div class="selection-actions">
      <p-button label="Désélectionner" icon="pi pi-times" (onClick)="clearSelection()"
        styleClass="p-button-text p-button-sm"></p-button>
    </div>
  </div>

  <div class="table-container">
    <p-table
      [value]="agendaProjects"
      [loading]="loading"
      [paginator]="true"
      [lazy]="true"
      [lazyLoadOnInit]="false"
      [totalRecords]="totalRecords"
      [rows]="rows"
      [first]="first"
      [rowsPerPageOptions]="[5,10,25,50]"
      (onLazyLoad)="onPageChange($event)"
      [showCurrentPageReport]="true"
      currentPageReportTemplate="Affichage de {first} à {last} sur {totalRecords} RDV santé"
      responsiveLayout="scroll"
      dataKey="id">

      <ng-template pTemplate="header">
        <tr>
          <th style="width: 3rem">
            <p-checkbox [binary]="true" [ngModel]="areAllVisibleSelected()"
              [indeterminate]="areSomeVisibleSelected() && !areAllVisibleSelected()"
              [disabled]="!hasSelectableVisibleProjects()" (onChange)="toggleAllSelection($event)"
              pTooltip="Tout sélectionner">
            </p-checkbox>
          </th>
          <th>Client</th>
          <th>Email</th>
          <th>Téléphone</th>
          <th>Objet</th>
          <th>RDV</th>
          <th>Statut lead</th>
          <th>Actions</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-item>
        <tr [class.selected-row]="isProjectSelected(item)">
          <td>
            <p-checkbox [binary]="true" [ngModel]="isProjectSelected(item)" [disabled]="!canSelectProject(item)"
              (onChange)="toggleProjectSelection(item, $event)">
            </p-checkbox>
          </td>

          <td>
            <div class="client-info">
              <div class="client-avatar">{{ getClientInitials(item) }}</div>
              <div class="client-details-text">
                <div class="client-name">{{ getClientShortName(item) }}</div>
                <div class="client-meta-tags">
                  <p-tag *ngIf="getVendeurName(item) !== '-'" [value]="getVendeurName(item)" severity="info"
                    [rounded]="true" icon="pi pi-user" styleClass="meta-tag"></p-tag>
                  <p-tag *ngIf="getRdvTakerName(item)" [value]="getRdvTakerName(item)!" severity="secondary"
                    [rounded]="true" icon="pi pi-calendar-plus" styleClass="meta-tag"></p-tag>
                  <p-tag *ngIf="item.origine" [value]="getOrigineLabel(item.origine)"
                    [severity]="getOrigineColor(item.origine)" [rounded]="true" styleClass="meta-tag"></p-tag>
                </div>
              </div>
            </div>
          </td>

          <td>
            <a *ngIf="item.email; else noEmail" [href]="'mailto:' + item.email" class="contact-link">{{ item.email }}</a>
            <ng-template #noEmail><span class="text-muted">-</span></ng-template>
          </td>

          <td>
            <a *ngIf="item.telephone; else noPhone" [href]="'tel:' + item.telephone" class="contact-link">{{ item.telephone }}</a>
            <ng-template #noPhone><span class="text-muted">-</span></ng-template>
          </td>

          <td>
            <div class="comment-cell" *ngIf="editingCommentId !== item.id; else editCommentTpl">
              <span class="comment-text" *ngIf="item.commentaire; else noComment"
                [pTooltip]="item.commentaire">{{ item.commentaire }}</span>
              <ng-template #noComment><span class="text-muted">-</span></ng-template>
              <button class="edit-date-btn" (click)="startEditComment(item)" pTooltip="Modifier l'objet">
                <i class="pi pi-pencil"></i>
              </button>
            </div>
            <ng-template #editCommentTpl>
              <div class="edit-comment-cell">
                <textarea
                  [(ngModel)]="editComment"
                  rows="3"
                  class="edit-comment-input"
                  placeholder="Ce qu'on a fait avec ce contact…"></textarea>
                <div class="edit-date-actions">
                  <button class="edit-date-save" (click)="saveComment(item)" [disabled]="savingCommentId === item.id" pTooltip="Enregistrer">
                    <i class="pi pi-check"></i>
                  </button>
                  <button class="edit-date-cancel" (click)="cancelEditComment()" pTooltip="Annuler">
                    <i class="pi pi-times"></i>
                  </button>
                </div>
              </div>
            </ng-template>
          </td>

          <td>
            <div class="agenda-cell" *ngIf="editingItemId !== item.id; else editDateTpl">
              <div class="agenda-date" [class.today-badge]="formatDate(item.startAt).startsWith('Aujourd')">
                {{ formatDate(item.startAt) }}
              </div>
              <button class="edit-date-btn" (click)="startEditDate(item)" pTooltip="Modifier la date/heure">
                <i class="pi pi-pencil"></i>
              </button>
            </div>
            <ng-template #editDateTpl>
              <div class="edit-date-cell">
                <input
                  type="datetime-local"
                  [(ngModel)]="editStartAt"
                  class="edit-date-input" />
                <div class="edit-date-actions">
                  <button class="edit-date-save" (click)="saveDate(item)" [disabled]="savingDateId === item.id" pTooltip="Enregistrer">
                    <i class="pi pi-check"></i>
                  </button>
                  <button class="edit-date-cancel" (click)="cancelEditDate()" pTooltip="Annuler">
                    <i class="pi pi-times"></i>
                  </button>
                </div>
              </div>
            </ng-template>
          </td>

          <td>
            <p-dropdown
              [options]="statusOptions"
              [ngModel]="item.status || 'nouveau'"
              optionLabel="label"
              optionValue="value"
              appendTo="body"
              styleClass="lead-status-dropdown"
              [disabled]="savingLeadStatusId === item.id || !canSelectProject(item)"
              (onChange)="onLeadStatusChange(item, $event.value)">
            </p-dropdown>
          </td><td><div class="row-action-buttons">
              <p-button
                icon="pi pi-eye"
                pTooltip="Voir les détails"
                (onClick)="viewAgendaCas(item)"
                [disabled]="loading"
                styleClass="p-button-text p-button-info">
              </p-button>

              <p-button
                icon="pi pi-phone"
                pTooltip="Appeler"
                (onClick)="openCall(item)"
                [disabled]="!item.telephone"
                styleClass="p-button-text p-button-success">
              </p-button>

              <p-button
                label="SMS"
                pTooltip="Envoyer un SMS"
                (onClick)="openSms(item)"
                [loading]="sendingSmsId === item.id"
                [disabled]="!item.telephone || sendingSmsId === item.id"
                styleClass="p-button-text p-button-warning sms-text-btn">
              </p-button>

              <p-button
                icon="pi pi-comment"
                [pTooltip]="item.commentaire || 'Aucun commentaire'"
                (onClick)="openComment(item)"
                [styleClass]="item.commentaire ? 'p-button-text btn-comment has-comment' : 'p-button-text btn-comment'">
              </p-button>

              <p-button
                icon="pi pi-upload"
                pTooltip="Charger dans le comparateur"
                (onClick)="loadAgendaCas(item)"
                [loading]="convertingId === item.id"
                [disabled]="loading || deletingId === item.id"
                styleClass="p-button-text p-button-success">
              </p-button>

              <p-button
                [icon]="item.isArchived ? 'pi pi-replay' : 'pi pi-inbox'"
                [pTooltip]="item.isArchived ? 'Désarchiver' : 'Archiver'"
                (onClick)="toggleArchive(item)"
                [loading]="archivingId === item.id"
                [disabled]="loading || deletingId === item.id || !canSelectProject(item)"
                styleClass="p-button-text p-button-secondary">
              </p-button>

              <p-button
                icon="pi pi-trash"
                pTooltip="Supprimer"
                (onClick)="confirmDelete(item)"
                [loading]="deletingId === item.id"
                [disabled]="loading || convertingId === item.id"
                styleClass="p-button-text p-button-danger">
              </p-button>
            </div>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="8">
            <div class="empty-state">
              <i class="pi pi-calendar"></i>
              <h3>Aucun RDV santé trouvé</h3>
              <p>Les cartes récupérées depuis Google Agenda apparaîtront ici.</p>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>

<p-dialog
  [(visible)]="showDetailDialog"
  [modal]="true"
  [style]="{width: '720px'}"
  [closable]="true"
  [draggable]="false"
  [resizable]="false"
  styleClass="agenda-detail-dialog"
  (onHide)="closeDetailDialog()">
  <ng-template pTemplate="header">
    <div class="detail-dialog-header">
      <i class="pi pi-calendar"></i>
      <div>
        <h3>Détails Projet Agenda</h3>
        <p *ngIf="selectedAgendaCas">{{ getClientName(selectedAgendaCas) }}</p>
      </div>
    </div>
  </ng-template>

  <ng-template pTemplate="content">
    <div class="detail-grid" *ngIf="selectedAgendaCas">
      <div class="detail-item" *ngFor="let entry of getAgendaCasDetailEntries(selectedAgendaCas)">
        <span class="detail-label">{{ entry.label }}</span>
        <pre class="detail-value">{{ formatValue(entry.value) }}</pre>
      </div>
      <div class="detail-item" style="grid-column: 1 / -1; margin-top: 15px;">
        <span class="detail-label">Éditer le commentaire</span>
        <textarea pInputTextarea [(ngModel)]="selectedAgendaCas.commentaire" rows="3" style="width: 100%; margin-top: 5px; resize: vertical;"></textarea>
        <button pButton label="Enregistrer le commentaire" icon="pi pi-save" class="p-button-sm p-button-outlined mt-2" (click)="saveCommentaire(selectedAgendaCas)"></button>
      </div>
    </div>
  </ng-template>

  <ng-template pTemplate="footer">
    <div class="detail-footer">
      <p-button
        label="Fermer"
        icon="pi pi-times"
        (onClick)="closeDetailDialog()"
        styleClass="p-button-text p-button-secondary">
      </p-button>

      <p-button
        label="Charger"
        icon="pi pi-upload"
        *ngIf="selectedAgendaCas"
        (onClick)="loadAgendaCas(selectedAgendaCas)"
        [loading]="convertingId === selectedAgendaCas.id"
        styleClass="p-button-success">
      </p-button>
    </div>
  </ng-template>
</p-dialog>

<!-- Dialog commentaire -->
<p-dialog header="Commentaire" [(visible)]="commentDialogVisible" [modal]="true" [draggable]="false"
  [resizable]="false" [style]="{width: '520px', maxWidth: '95vw'}">
  <div style="display:flex;flex-direction:column;gap:8px">
    <div style="font-size:12px;color:#888">{{ commentDialogTitle }}</div>
    <div style="white-space:pre-wrap;font-size:.9rem;line-height:1.5;color:#334155">
      {{ commentDialogText || 'Aucun commentaire.' }}
    </div>
  </div>
  <ng-template pTemplate="footer">
    <button pButton type="button" label="Fermer" icon="pi pi-times"
      class="p-button-text p-button-secondary" (click)="commentDialogVisible = false">
    </button>
  </ng-template>
</p-dialog>
